<div *ngIf="visible" [id]="code">
  <h4 *ngIf="showHeader">
    <strong>{{subSection.subsectionTitle}}</strong>
  </h4>
  <app-element *ngFor="let element of subSection.subSectionElements" [element]="element"
    [layout]="layout">
  </app-element>
</div>